import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { PriorityRestService } from "@app/services/hal/priority-rest.service";
import { Priority } from "@app/models/rest/priority";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class PriorityStore extends RealTimeDataStore<Priority> {
  constructor() {
    const priorityRestService = inject(PriorityRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(priorityRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Priority", true);
  }
}
